/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect } from "react";
import classes from "./TicketLargeGroup.module.scss";
import * as ROUTES from "../../constants/routes";
import FormController from "../../components/FormController/FormController";
import { useModal } from "react-hooks-use-modal";
// import SeatingMap from '../../components/FormSelectYourSeat/SeatingMap';
// import SeatingMap from '../../components/FormSelectYourSeat/SeatingMap';

const TicketLargeGroup = (props) => {
  const [Modal, open, close, isOpen] = useModal("root", {
    preventScroll: true,
    closeOnOverlayClick: true,
  });
  useEffect(() => {
    if (window.adobeAnalytics) {
      window.adobeAnalytics.t({
        pageName:
          "Washington Nationals: Tickets: Nationals Ticketfinder: Group tickets and experiences",
      });
    }
  }, []);
  return (
    <>
      <div className={classes.TicketLargeGroup}>
        {/* <SeatingMap
          seatsInfo={[{ name: 'fortyClassic' }]}
          seatInfoSelectedKey={0}
        /> */}
        <div className={classes.FormTitle}>
          Group Tickets, Luxury Suites & Experiences
        </div>
        <div className={classes.content}>
          <p className={classes.title}>
            Nationals games are the perfect event for companies, schools,
            non-profits, associations, and youth sports leagues. Reserving a
            group is easy, and a wide range of seating and pricing options is
            available, including luxury suites. Plus, you will get tons of great
            benefits:
          </p>
          <div className={classes.content_col}>
            <div className={classes.content_col_items}>
              {/* <div className={classes.content_col_item}>
                <img
                  src={require(`../../assets/images/icons/present.png`)}
                  alt=""
                />
                <span className={classes.red}>
                  Receive a FREE 50% Bonus Credit for Group Tickets or Luxury
                  Suites purchased by December 15, 2020*. Use your bonus credit
                  towards concessions, merchandise, aditional tickets and more!
                </span>
              </div> */}
              <div className={classes.content_col_item}>
                <img
                  src={require(`../../assets/images/icons/icons-2.png`)}
                  alt=""
                />
                <span>
                  Discounted tickets for groups of 20 or more - the larger the
                  group, the larger the savings!
                </span>
              </div>
              {/* <div className={classes.content_col_item}>
                <img
                  src={require(`../../assets/images/icons/icons-3.png`)}
                  alt=""
                />
                <span>No per-ticket fees</span>
              </div> */}
              <div className={classes.content_col_item}>
                <img
                  src={require(`../../assets/images/icons/icons-1.png`)}
                  alt=""
                />
                <span>
                  Reserved seating, allowing your group to enjoy the game
                  together
                </span>
              </div>
            </div>
            <div className={classes.content_col_items}>
              {/* <div className={classes.content_col_item}>
                <img
                  src={require(`../../assets/images/icons/icons-7.png`)}
                  alt=""
                />
                <span>Scoreboard messages for groups of 50 or more</span>
              </div> */}
              <div className={classes.content_col_item}>
                <img
                  src={require(`../../assets/images/icons/icons-5.png`)}
                  alt=""
                />
                <span>
                  Pregame hospitality areas and meeting spaces available for
                  booking
                </span>
              </div>
              <div className={classes.content_col_item}>
                <img
                  src={require(`../../assets/images/icons/icons-4.png`)}
                  alt=""
                />
                <span>
                  Unique on-field experiences available to groups that qualify,
                  including pregame performances, first pitch, play ball
                  announcement, Presidents Race finish line, and more!
                </span>
              </div>
            </div>
          </div>

          {/* <p className={classes.disclaimer}>
            *50% Bonus Credit calculated based on the amount paid towards
            qualifying new 2021 ticket purchases on or before December 15, 2020,
            less all associated fees. For 50% Bonus Credit program terms &
            conditions, please visit{" "}
            <a
              href="http://www.nationals.com/bonusterms"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.nationals.com/bonusterms
            </a>
            .
          </p> */}
        </div>
        <div className={classes.buttons}>
          <div className={classes.button_item}>
            <p className={classes.button_item_bold}>
              Select your game, your seats, and finalize your purchase directly
              through TicketFinder!
            </p>
            <a
              href="https://mpv.tickets.com/schedule/?agency=MLB_MPV&orgid=17#/sales_groups;salesGroupId=2660"
              rel="noopener noreferrer"
              target="_blank"
              className={classes.greenButton}
            >
              Purchase Group Outing <br /> of 20-99 Tickets
            </a>
          </div>
          <div className={classes.button_item}>
            <p>
              Are you interested in a group outing, but not ready to lock in
              your exact game or quantity of tickets? Or are you looking to book
              a group of 100+ tickets or a Luxury Suite? Secure your priority
              with an Initial Payment!{" "}
              <a className={classes.more_info} onClick={open}>
                More Info
              </a>
            </p>
            <div>
              <Modal>
                <div className={classes.modal_content}>
                  <p>
                    Your initial payment will prioritize you for access to the
                    best seats and hottest games in 2022. Your initial payment
                    will be applied to your final purchase. Click below to
                    customize the size of your initial payment, choosing between
                    increments of $250 for Group Tickets or increments of $1,000
                    for Luxury Suites.
                  </p>
                  <button onClick={close}>✕</button>
                </div>
              </Modal>
            </div>
            <a
              href="https://mpv.tickets.com/?orgid=17&agency=MLB_MPV&pid=8992072&coupon=2022GROUPDEPOSIT&exclusivecoupon=true"
              rel="noopener noreferrer"
              target="_blank"
              className={classes.redButton}
            >
              Make Initial <br /> Payment
            </a>
          </div>
          <div className={classes.button_item}>
            <p>
              Need to discuss your Group Ticket or Luxury Suite options further?
              Our Group Sales representatives are standing by during normal
              business hours.
            </p>
            <a
              onClick={() => {
                window.chatBtn();
                if (window.adobeAnalytics && window.adobeAnalytics.tl) {
                  window.adobeAnalytics.tl(
                    true,
                    "o",
                    "Washington Nationals: Tickets: Nationals Ticketfinder: Group tickets and experiences",
                    {
                      prop12: "navigation",
                      prop13:
                        "Washington Nationals: Tickets: Nationals Ticketfinder: Group tickets and experiences",
                      prop14: `chat with a representative click`,
                      evar140: "Chat with a Nationals Representative",
                    }
                  );
                }
              }}
              className={classes.blueButton}
            >
              Chat with a Nationals <br /> Representative
            </a>
          </div>
        </div>
      </div>
      <FormController
        backTo={ROUTES.PAGE_1_LINK}
        nextTo={ROUTES.PAGE_3_LINK}
        startOver={ROUTES.PAGE_1_LINK}
        showBack={true}
        showStartOver={false}
        showSkip={false}
        showSubmit={false}
      />
    </>
  );
};

export default TicketLargeGroup;
